import * as React from 'react'

export const CloseIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='header-close-icon'
    >
      <path d='M13 3.5L3 13.5' stroke='#64748B' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M3 3.5L13 13.5' stroke='#64748B' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  )
}
